import { ListItem, Box, OrderedList, UnorderedList } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface TermsListProps {
  items: ReactNode[];
  ordered?: boolean;
  noMargin?: boolean;
}

export const TermsList = ({ items, ordered = false, noMargin = false }: TermsListProps) => {
  const ListComponent = ordered ? OrderedList : UnorderedList;

  return (
    <ListComponent
      spacing="8px"
      pl={ordered ? 4 : 0}
      mb={noMargin ? 0 : '16px'}
      fontSize="md"
      lineHeight="28px"
      fontWeight={400}
      letterSpacing="0"
      color="#4A5769"
      fontFamily="primary"
      ml={{ base: 0, md: '16px' }}
    >
      {items.map((item, idx) => (
        <ListItem
          key={idx}
          {...(!ordered && {
            display: 'flex',
            alignItems: 'flex-start',
          })}
        >
          {!ordered && (
            <Box
              width="8px"
              height="8px"
              bg="#A71C29"
              borderRadius="2px"
              transform="rotate(45deg)"
              mt="8px"
              mr="16px"
              flexShrink={0}
            />
          )}
          {item}
        </ListItem>
      ))}
    </ListComponent>
  );
};
